export enum ModalType {
    MIDDLE = 'MIDDLE',
    MINI_MODAL = 'MINI_MODAL',
    SIDE = 'SIDE',
    COMPARE = 'COMPARE',
    CART = ' CART'
}
